import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import EditableInput from '../../components/EditableInput';
import EditableSelect from './../../components/EditableSelect';
import UneditableInput from '../../components/UneditableInput';

import { getShortsData, updateShort } from '../../services/short';
import { showAlert } from '../../store/ducks/alert';

import { Button, Switch, FormControlLabel, CircularProgress } from '@material-ui/core';
import { Save } from '@material-ui/icons';

const ShortsInformation = props => {
  const dispatch = useDispatch();
  const [short, setShort] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    displayShort();
  }, []);

  const handleUpdate = async e => {
    e.preventDefault();

    try {
      await updateShort(short.id, short);
      dispatch(showAlert('success', 'Short has been updated! 🔥'));
    } catch (error) {
      dispatch(showAlert('error', 'Error! We could not update the Short. 😔'));
      console.log(error);
    }
  };

  const displayShort = async () => {
    const shortId = props.match.params.id;
    try {
      setIsLoading(true);
      const { data } = await getShortsData(0, { searchItem: 'id', search: shortId });

      setShort(data.rows[0]);

      setIsLoading(false);
    } catch (error) {
      dispatch(showAlert('error', 'Ops! We could not load this Short. 😔'));
      console.log(error);
    }
  };

  const editable = ['slug', 'textSelection', 'title', 'type', 'textSelection'];

  const select = ['forMembers', 'forNonMembers', 'forSubscribers', 'isPinned', 'isReply'];

  const uneditable = [
    'id',
    'channelId',
    'issueId',
    'userId',
    'createdAt',
    'updatedAt',
    'deletedAt',
    'shortIdAnswered',
    'temporaryId',
    'transactionId',
  ];

  if (isLoading) return <CircularProgress color="inherit" className="circular-progress" />;

  return (
    <>
      <div className="page-header">
        <h1>{short.subject}</h1>
        <FormControlLabel
          control={
            <Switch
              className="enabled-switch"
              checked={short.isPublic}
              onChange={e => setShort({ ...short, [e.target.name]: e.target.checked })}
              name="isPublic"
              color="primary"
            />
          }
          label="Public"
          labelPlacement="start"
        />
      </div>

      <section className="update-section">
        <h3>Edit Short</h3>
        <form onSubmit={handleUpdate} className="update-form">
          <div className="form-fields">
            <EditableInput data={short} setData={setShort} labels={editable} />
            <EditableSelect data={short} setData={setShort} labels={select} />
            <EditableSelect data={short} setData={setShort} labels={['deletedAt']} isDeletedAt />
            <UneditableInput data={short} labels={uneditable} />
          </div>
          <Button type="submit" className="update-btn" variant="contained" startIcon={<Save />}>
            Update Short
          </Button>
        </form>
      </section>
    </>
  );
};

export default ShortsInformation;
